import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CourseSetup/desktop';
import Mobile from 'pages/CourseSetup/mobile';
import { PageContext } from 'pages/CourseSetup/PageProvider';
import Tablet from 'pages/CourseSetup/tablet';
import { useContext } from 'react';
import { AlertDialog, Loading } from 'shell/components';

const PageLayout = () => {
    const { device } = useViewport();
    const { loading, dialog, setDialog } = useContext(PageContext);

    const renderResponsiveLayouts = (device) => {
        return {
            mobile: <Mobile />,
            tablet: <Tablet />,
            desktop: <Desktop />,
        }[device];
    };

    return loading ? (
        <Loading />
    ) : (
        <>
            {renderResponsiveLayouts(device)}
            <AlertDialog
                message={dialog.message}
                description={dialog.description}
                open={dialog.open}
                variant={dialog.variant}
                actionButtonText={dialog.actionButtonText}
                onAction={dialog.onAction}
                onCancel={() => setDialog((current) => ({ ...current, open: false }))}
                onClose={() => setDialog((current) => ({ ...current, open: false }))}
            />
        </>
    );
};

export default PageLayout;
